import type { FeatureToggles } from '@/overmind';
import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import type { ShortCircuitScenarioElementCalculation } from '../../../..';
import type { ForStoringAttentionStatus2 } from '../../../../evaluation/AttentionStatusRepository';
import type { ForRuleProviding } from '../../../../evaluation/RulesProvider';
import { FaultCurrentEvaluationEngine } from '../../../../evaluation/shortCircuit/engines/lowVoltage/faultCurrentEvaluationEngine';
import { DetailsWithResultsFactory } from '../Details';
import type { GridElementsShortCircuitDetails } from '../ShortCircuitDetails';
import { Features } from '../../../../createGridElementCalculationSetExecutionDetails';

export function createShortCircuitDetails(
  features: Features,
  shortCircuitScenarios: ShortCircuitScenarioElementCalculation[],
  rulesProvider: ForRuleProviding,
  attentionStatusStorage: ForStoringAttentionStatus2,
  featureToggles?: FeatureToggles
): GridElementsShortCircuitDetails {
  const evaluationEngine = new FaultCurrentEvaluationEngine(
    attentionStatusStorage,
    rulesProvider
  );
  const details = DetailsWithResultsFactory.create(
    features,
    shortCircuitScenarios,
    evaluationEngine,
    featureToggles
  );
  const energyConsumerShortCircuitResults = details.for('EnergyConsumer');

  const allResults = [...energyConsumerShortCircuitResults];

  return allResults;
}
